export const HIGHLIGHT_TONE_CLASSES = {
    success: {
        day: 'bg-success-subtle text-success-foreground',
        dot: 'bg-success-subtle ring-success',
        text: 'text-success-foreground',
    },
    warning: {
        day: 'bg-warning-subtle text-warning-foreground',
        dot: 'bg-warning-subtle ring-warning',
        text: 'text-warning-foreground',
    },
};
/** Modificateurs react-day-picker à passer au calendrier pour ces mises en avant. */
export function toHighlightModifiers(highlights = []) {
    return Object.fromEntries(highlights.map((h) => [`highlight_${h.tone}`, h.dates]));
}
